import { render } from "./PpcBAStateCell.vue?vue&type=template&id=a4fc72b8&scoped=true"
import script from "./PpcBAStateCell.vue?vue&type=script&lang=js"
export * from "./PpcBAStateCell.vue?vue&type=script&lang=js"

import "./PpcBAStateCell.vue?vue&type=style&index=0&id=a4fc72b8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4fc72b8"]])

export default __exports__